import BreadcrumbsComponent from './breadcrumbs';

export default BreadcrumbsComponent;
